import { GetStaticPaths, GetStaticPropsContext } from 'next';
import { useTranslation } from 'next-i18next';
import { serverSideTranslations } from 'next-i18next/serverSideTranslations';
import styled from 'styled-components';
import { getFilterOptions, getFooterLinks } from '../../../../new-lib/apis';
import { useRouter } from 'next/router';
import {
  setExperimentVariant,
  setIsMobile,
  setWebview,
  WEBVIEW
} from '../../../../redux/actions/appActions';
import { wrapper } from '../../../../redux/store';
import { useSelector } from 'react-redux';
import { StaticPagesUtility } from '../../../../new-lib/utilities/static-pages.utility';
import { ConfigsApis } from '../../../../new-lib/apis/configs.apis';

const Terms = () => {
  const { t } = useTranslation('terms');
  const { locale } = useRouter();

  const webview = useSelector((state: any) => state.app.webview);

  return (
    <TermsContainer className="container-fluid">
      <div className="termsHeader">
        {webview !== 'app' && (
          <h1 id="terms-header">{t('terms_and_condittions')}</h1>
        )}
        <p>{t(`terms_header`)}</p>
      </div>
      <div className="termsContent">
        <div className="sectionContent">
          <h2>{t('permissible_use')}</h2>
          <p>{t('terms_i')}</p>
        </div>
        <div className="sectionContent">
          <h2>{t('acceptable_use')}</h2>
          <p>{t('terms_ii')}</p>
        </div>
        <div className="sectionContent">
          <h2>{t('automated_queries')}</h2>
          <p>
            {t('terms_iii')}
            <br />
            <br />
            {t('terms_iiii')}
            <br />
            <br />
            {t('terms_iv')}
            <br />
            <br />
            {locale == 'en' && (
              <>
                {t('terms_v')}
                <br />
                <br />
              </>
            )}
            {t('terms_vi')}
          </p>
        </div>
      </div>

      <div className="termsContent">
        <div className="sectionContent">
          <h2>{t('nawy_role')}</h2>
          <p>{t('terms_vii')}</p>
        </div>
        <div className="sectionContent">
          <h2>{t('intellectual_property')}</h2>
          <p>{t('terms_viii')}</p>
        </div>
        <div className="sectionContent">
          <h2>{t('liability')}</h2>
          <p>{t('terms_ix')}</p>
        </div>
        <div className="sectionContent">
          <h2>{t('changes')}</h2>
          <p>{t('terms_x')}</p>
        </div>
        <div className="sectionContent">
          <h2>{t('choice_of_law')}</h2>
          <p>{t('terms_xi')}</p>
        </div>
        <div className="sectionContent">
          <h2>{t('indemnification')}</h2>
          <p>{t('terms_xii')}</p>
        </div>
        <div className="sectionContent">
          <h2>{t('release')}</h2>
          <p>{t('terms_xiii')}</p>
        </div>
        <div className="sectionContent">
          <h2>{t('general')}</h2>
          <p>{t('terms_xiv')}</p>
        </div>
      </div>
    </TermsContainer>
  );
};

const TermsContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
  height: auto;
  padding: 30px 0px;

  .termsHeader {
    display: flex;
    flex-direction: column;
    gap: 16px;
    h1 {
      color: #0c314e;
      font-size: ${props => props.theme.font.sizes.xxxxl};
      font-family: materialBold;
    }
    p {
      font-family: materialRegular;
      font-size: ${props => props.theme.font.sizes.l};
      color: ${props => props.theme.light.colors.black};
    }
  }
  .termsContent {
    display: flex;
    flex-direction: column;
    gap: 16px;
    .sectionContent {
      display: flex;
      flex-direction: column;
      gap: 5px;
      h2 {
        font-family: materialBold;
        font-size: ${props => props.theme.font.sizes.xl};
        color: ${props => props.theme.light.colors.black};
      }
      p {
        font-family: materialRegular;
        font-size: ${props => props.theme.font.sizes.l};
        color: ${props => props.theme.light.colors.black};
      }
    }
  }

  @media screen and (max-width: ${props =>
      props.theme.breakPoints.tablet.max}) {
    padding: 16px;
    h1 {
      font-size: ${props => props.theme.font.sizes.xxxxl} !important;
    }
    h2,
    p {
      font-size: ${props => props.theme.font.sizes.s} !important;
    }
  }
`;

export const getStaticProps = wrapper.getStaticProps(
  store =>
    async ({ params, locale }: GetStaticPropsContext) => {
      const [footerLinks, configVariables, filterOptions] = await Promise.all([
        getFooterLinks(locale, 'terms'),
        ConfigsApis.getConfigs(locale),
        getFilterOptions(locale)
      ]);

      if (params?.platform === 'app') {
        store.dispatch(setWebview(WEBVIEW.APP));
      }
      store.dispatch(setIsMobile(params?.device === 'mobile'));
      store.dispatch(setExperimentVariant(params?.variant as string));

      return {
        revalidate: 60 * 60 * 24,
        props: {
          ...(await serverSideTranslations(locale as string, [
            'terms',
            'common',
            'contact'
          ])),
          filterOptions: JSON.stringify(filterOptions) || '',
          configVariables,
          layout: {
            footerLinks
          }
        }
      };
    }
);

export const getStaticPaths = (async () => {
  return { paths: StaticPagesUtility.getWithPlatform(), fallback: false };
}) satisfies GetStaticPaths;

export default Terms;
